/* ----------------------------------------------------------------------------
   CUSTOM PRODUCT BLOCKS — JavaScript
   Loaded once from sections/main-product.liquid.

   <cb-buy-box> keeps the price shown inside the add-to-cart button in sync
   with the chosen quantity (unit price comes from Liquid and is refreshed by
   the theme's own re-render on variant change; this element only multiplies
   it by the quantity). Defined as a custom element so it re-initializes
   automatically whenever the theme re-renders the product info.
   ---------------------------------------------------------------------------- */

(function () {
  if (window.customElements.get('cb-buy-box')) {
    return;
  }

  class CBBuyBox extends HTMLElement {
    connectedCallback() {
      this._input = this.querySelector('input[name="quantity"]');
      this._price = this.querySelector('[data-cb-price]');

      if (!this._input || !this._price || this._price.dataset.multiplyQty !== 'true') {
        return;
      }

      this._unitPrice = parseInt(this._price.dataset.unitPrice, 10);

      if (isNaN(this._unitPrice)) {
        return;
      }

      this._onQuantityChange = this._update.bind(this);
      this._input.addEventListener('input', this._onQuantityChange);
      this._input.addEventListener('change', this._onQuantityChange);
      this._update();
    }

    disconnectedCallback() {
      if (this._onQuantityChange && this._input) {
        this._input.removeEventListener('input', this._onQuantityChange);
        this._input.removeEventListener('change', this._onQuantityChange);
      }
    }

    _update() {
      var quantity = parseInt(this._input.value, 10);

      if (isNaN(quantity) || quantity < 1) {
        quantity = 1;
      }

      this._price.innerHTML = this._formatMoney(this._unitPrice * quantity);
    }

    _formatMoney(cents) {
      var format = this.dataset.moneyFormat || '${{amount}}';
      var placeholderMatch = format.match(/\{\{\s*(\w+)\s*\}\}/);
      var placeholder = placeholderMatch ? placeholderMatch[1] : 'amount';
      var value = '';

      function withSeparators(number, decimals, thousands, decimal) {
        var parts = (number / 100).toFixed(decimals).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts.join(decimal);
      }

      switch (placeholder) {
        case 'amount_no_decimals':
          value = withSeparators(cents, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          value = withSeparators(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = withSeparators(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = withSeparators(cents, 2, "'", '.');
          break;
        default:
          value = withSeparators(cents, 2, ',', '.');
      }

      return format.replace(/\{\{\s*\w+\s*\}\}/, value);
    }
  }

  window.customElements.define('cb-buy-box', CBBuyBox);
})();


/* ----------------------------------------------------------------------------
   Quick-buy "Checkout" button: posts the form's current selection to the cart,
   then goes straight to checkout. Delegated at document level so it works for
   quick-buy popups injected dynamically on any page.
   ---------------------------------------------------------------------------- */

(function () {
  if (window.__cbQuickCheckoutBound) {
    return;
  }
  window.__cbQuickCheckoutBound = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-cb-quick-checkout]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') {
      return;
    }

    var form = document.getElementById(btn.getAttribute('data-form'));
    if (!form) {
      return;
    }

    event.preventDefault();
    btn.setAttribute('aria-busy', 'true');

    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('cart add failed');
        }
        window.location.href = '/checkout';
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        if (form.requestSubmit) {
          form.requestSubmit();
        }
      });
  });
})();